// extracted by mini-css-extract-plugin
export default {"loadingDesktop":"SearchResultPanelContent-module__loadingDesktop___3zv2L","loadingMobile":"SearchResultPanelContent-module__loadingMobile___1cPhs"};